import ApiService from './ApiService'
export default class UsuarioService extends ApiService {
  constructor() {
    super('/users')
  }

  async autenticar(credenciais) {
    return await this.post('/auth/local', credenciais)
  }

  // obterStatus(id, token) {
  //   return this.get(`/users/${id}/status`, token)
  // }
}
